import { Fragment, type FC } from 'react'

import { Separator } from '@wartek-id/separator'

import {
  TextLabel,
  TextValue,
} from 'app/KinerjaKSPage/components/EvaluationResultV2/components/Texts'
import Grid from 'app/KinerjaKSPage/components/EvaluationResultV2/components/Grid'
import { convertToSlug } from 'utils/text'

type EvaluationResultDetailsProps = {
  data: Array<{
    label: string
    items: Array<{ label: string; value: string }>
  }>
}

// Used to define the grid layout for the details section
const childrenLeftProps = { className: 'col-span-4' },
  childrenRightProps = { className: 'col-span-4' }

const EvaluationResultDetails: FC<EvaluationResultDetailsProps> = ({
  data,
}) => {
  return (
    <>
      {data?.map((mappedData, index) => {
        const label = mappedData?.label
        return (
          <Fragment key={index}>
            <div className="space-y-1" data-testid={convertToSlug(label)}>
              <TextLabel
                data-testid={convertToSlug(`${label} label`)}
                className="capitalize"
              >
                {label}
              </TextLabel>

              {mappedData?.items.map((item, index2) => {
                const prefix = `${label} ${item.label}`
                return (
                  <Fragment key={`${index}-${index2}`}>
                    <Grid
                      childrenLeftProps={childrenLeftProps}
                      childrenRightProps={childrenRightProps}
                      childrenLeft={
                        <>
                          <TextValue
                            data-testid={convertToSlug(`${prefix} label`)}
                          >
                            {item.label}
                          </TextValue>
                        </>
                      }
                      childrenRight={
                        <div className="flex flex-row items-start gap-2">
                          <TextValue as="div" className="flex-none">
                            :
                          </TextValue>
                          <TextValue
                            as="div"
                            className="flex-1 overflow-wrap-anywhere"
                            data-testid={convertToSlug(`${prefix} value`)}
                          >
                            {item?.value || '-'}
                          </TextValue>
                        </div>
                      }
                    />
                  </Fragment>
                )
              })}
            </div>
            <Separator />
          </Fragment>
        )
      })}
    </>
  )
}
export default EvaluationResultDetails
